<template>
  <div class="container px-sm-0 bg-light">
    <div class="row adjust-margin">
      <div class="col">
        <div class="container px-sm-5">
          <!-- Utilisation du composant NewCandidacyForm -->
          <new-candidacy-form />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewCandidacyForm from '../components/NewCandidacyForm.vue'

export default {
  name: "NewCandidacy",
  components: {
    NewCandidacyForm
  }
}
</script>

<style scoped>
@media all and (max-width: 991px) {
  /* .adjust-margin {
    margin: 0px !important;
  } */
}
</style>